<template>
  <el-dialog
    :title="dialogTitle"
    :visible.sync="dialogVisible"
    width="80%"
    :close-on-click-modal="false"
    @close="handleClose"
  >
    <div class="scheme-edit-form">
      <el-form :model="form" :rules="rules" ref="schemeForm" label-width="120px">
        <!-- 基本信息 -->
        <div class="form-section">
          <h3 class="section-title">基本信息</h3>
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="选择产品:" prop="product_id">
                <el-select 
                  v-model="form.product_id" 
                  placeholder="请选择产品" 
                  filterable
                  :disabled="isView"
                  style="width: 100%;"
                >
                  <el-option
                    v-for="item in productOptions"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="保险公司:" prop="insurance_type">
                <el-select 
                  v-model="form.insurance_type" 
                  placeholder="请选择保险公司" 
                  filterable
                  :disabled="isView"
                  style="width: 100%;"
                >
                  <el-option
                    v-for="item in insuranceOptions"
                    :key="item.id"
                    :label="item.text"
                    :value="item.id"
                  />
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="承保险种:" prop="risk_type">
                <el-select 
                  v-model="form.risk_type" 
                  placeholder="请选择承保险种" 
                  :disabled="isView"
                  style="width: 100%;"
                >
                  <el-option
                    v-for="item in riskTypeOptions"
                    :key="item.id"
                    :label="item.text"
                    :value="item.id"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="佣金比例:" prop="commission_rate">
                <el-input-number 
                  v-model="form.commission_rate" 
                  :min="0" 
                  :max="100"
                  :precision="2"
                  :disabled="isView"
                  style="width: 100%;"
                  controls-position="right"
                /> %
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="方案名称:" prop="name">
                <el-input 
                  v-model="form.name" 
                  placeholder="请输入方案名称" 
                  :disabled="isView || (formData && formData.id)"
                  style="width: 100%;"
                />
              </el-form-item>
            </el-col>
            <el-col :span="12" v-if="schemeType === 'coverage_rate' || schemeType === 'freight_rate'">
              <el-form-item label="保险费率(%):" prop="rate">
                <el-input-number 
                  v-model="form.rate" 
                  :min="0" 
                  :max="100"
                  :precision="4"
                  :disabled="isView"
                  style="width: 100%;"
                  controls-position="right"
                />
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="最低保费(元):" prop="min_premium">
                <el-input-number 
                  v-model="form.min_premium" 
                  :min="0"
                  :precision="2"
                  :disabled="isView"
                  style="width: 100%;"
                  controls-position="right"
                />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="最高限额(万元):" prop="max_coverage">
                <el-input-number 
                  v-model="form.max_coverage" 
                  :min="0"
                  :precision="2"
                  :disabled="isView"
                  style="width: 100%;"
                  controls-position="right"
                />
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="支付渠道:" prop="pay_channel">
                <el-select 
                  v-model="form.pay_channel" 
                  placeholder="请选择支付渠道" 
                  :disabled="isView"
                  style="width: 100%;"
                >
                  <el-option
                    v-for="item in payChannelOptions"
                    :key="item.id"
                    :label="item.text"
                    :value="item.id"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="生效天数:" prop="effect_days">
                <el-input-number 
                  v-model="form.effect_days" 
                  :min="1"
                  :disabled="isView"
                  style="width: 100%;"
                  controls-position="right"
                />
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="支付方式:" prop="pay_type">
                <el-select 
                  v-model="form.pay_type" 
                  placeholder="请选择支付方式" 
                  :disabled="isView"
                  @change="handlePayTypeChange"
                  style="width: 100%;"
                >
                  <el-option
                    v-for="item in payTypeOptions"
                    :key="item.id"
                    :label="item.text"
                    :value="item.id"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="保单类型:" prop="policy_type">
                <el-radio-group v-model="form.policy_type" :disabled="isView" @change="handlePolicyTypeChange">
                  <el-radio :label="1">电子保单</el-radio>
                  <el-radio :label="2">承保确认单</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
          </el-row>
        </div>

        <!-- 功能配置 -->
        <div class="form-section" v-if="showFeatureConfig">
          <h3 class="section-title">功能配置</h3>
          <div v-if="isOnlinePayment">
            <el-checkbox v-model="form.is_allow_deposit_online" :disabled="isView">开通后台单产品用户充值功能和余额支付</el-checkbox><br/>
            <el-checkbox v-model="form.is_upload_agreement" :disabled="isView">开通上传协议文件</el-checkbox><br/>
            <el-checkbox v-model="form.is_upload_policy_file" :disabled="isView">开通上传电子保单文件</el-checkbox><br/>
          </div>
          <div v-else>
            <el-checkbox v-model="form.is_allow_deposit_online" :disabled="isView">开通在线充值</el-checkbox><br/>
            <el-checkbox v-model="showDepositMin" :disabled="isView">单次充值金额下限</el-checkbox>
            <el-input-number 
              v-if="showDepositMin" 
              v-model="form.deposit_min" 
              :min="0" 
              :precision="2"
              :disabled="isView"
              style="margin-left: 10px; width: 150px;"
            /> 元<br/>
            <el-checkbox v-model="form.is_allow_deposit_offline" :disabled="isView">开通后台余额维护</el-checkbox><br/>
          </div>
        </div>

        <!-- 出单配置 -->
        <div class="form-section">
          <h3 class="section-title">出单配置</h3>
          <div v-if="form.policy_type === 1">
            <el-form-item label="出单方案:" prop="policy_name">
              <el-input 
                v-model="form.policy_name" 
                placeholder="请输入出单方案" 
                :disabled="isView"
                style="width: 300px;"
              />
            </el-form-item>
          </div>
          <div v-else>
            <el-form-item label="起保时间:" prop="effect_time_type">
              <el-radio-group v-model="form.effect_time_type" :disabled="isView">
                <el-radio :label="1">十分钟后起保</el-radio>
                <el-radio :label="2">下一整点起保</el-radio>
              </el-radio-group>
            </el-form-item>
          </div>
        </div>

        <!-- 条款信息 -->
        <div class="form-section">
          <h3 class="section-title">条款信息</h3>
          <el-form-item label="保险标的:">
            <el-input 
              type="textarea" 
              v-model="form.insurance_item" 
              :rows="3"
              :disabled="isView"
              style="width: 100%;"
              placeholder="请输入保险标的"
            />
          </el-form-item>
          <el-form-item label="免赔额约定:">
            <el-input 
              type="textarea" 
              v-model="form.deductible" 
              :rows="3"
              :disabled="isView"
              style="width: 100%;"
              placeholder="请输入免赔额约定"
            />
          </el-form-item>
          <el-form-item label="特别约定:">
            <el-input 
              type="textarea" 
              v-model="form.special_clauses" 
              :rows="4"
              :disabled="isView"
              style="width: 100%;"
              placeholder="请输入特别约定"
            />
          </el-form-item>
          <el-form-item label="附加条款:">
            <el-input 
              type="textarea" 
              v-model="form.extension_clauses" 
              :rows="3"
              :disabled="isView"
              style="width: 100%;"
              placeholder="请输入附加条款"
            />
          </el-form-item>
          <el-form-item label="不予承保说明:">
            <el-input 
              type="textarea" 
              v-model="form.warranty_against_cargo" 
              :rows="3"
              :disabled="isView"
              style="width: 100%;"
              placeholder="请输入不予承保说明"
            />
          </el-form-item>
          <el-form-item label="保险理赔服务:">
            <el-input 
              type="textarea" 
              v-model="form.claim_service" 
              :rows="3"
              :disabled="isView"
              style="width: 100%;"
              placeholder="请输入保险理赔服务"
            />
          </el-form-item>
          <el-form-item v-if="form.policy_type === 2" label="承保确认单备注:">
            <el-input 
              type="textarea" 
              v-model="form.policy_remark" 
              :rows="3"
              :disabled="isView"
              style="width: 100%;"
              placeholder="请输入承保确认单备注"
            />
          </el-form-item>
        </div>
      </el-form>
    </div>

    <div slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取 消</el-button>
      <el-button v-if="!isView" type="primary" @click="handleSave" :loading="loading">
        保 存
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import { 
  saveScheme, 
  getSchemeInfo,
  getProductList,
  getInsuranceCompanyList 
} from '@/api/product'

export default {
  name: 'SchemeEditDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    formData: {
      type: Object,
      default: null
    },
    isView: {
      type: Boolean,
      default: false
    },
    schemeType: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      loading: false,
      form: {
        id: null,
        product_id: '',
        insurance_type: '',
        risk_type: '',
        commission_rate: 0,
        name: '',
        rate: 0,
        min_premium: 0,
        max_coverage: 0,
        pay_channel: '',
        effect_days: 1,
        pay_type: '',
        policy_type: 1,
        effect_time_type: 1,
        policy_name: '',
        is_allow_deposit_online: false,
        is_upload_agreement: false,
        is_upload_policy_file: false,
        is_allow_deposit_offline: false,
        deposit_min: 0,
        insurance_item: '',
        deductible: '',
        special_clauses: '',
        extension_clauses: '',
        warranty_against_cargo: '',
        claim_service: '',
        policy_remark: ''
      },
      rules: {
        product_id: [{ required: true, message: '请选择产品', trigger: 'change' }],
        insurance_type: [{ required: true, message: '请选择保险公司', trigger: 'change' }],
        risk_type: [{ required: true, message: '请选择承保险种', trigger: 'change' }],
        name: [{ required: true, message: '请输入方案名称', trigger: 'blur' }],
        pay_channel: [{ required: true, message: '请选择支付渠道', trigger: 'change' }],
        pay_type: [{ required: true, message: '请选择支付方式', trigger: 'change' }]
      },
      // 选项数据
      productOptions: [],
      insuranceOptions: [],
      riskTypeOptions: [
        { id: 1, text: '物流责任险' },
        { id: 2, text: '雇主责任险' },
        { id: 4, text: '财产基本险' },
        { id: 8, text: '财产综合险' },
        { id: 16, text: '公路运输险' },
        { id: 32, text: '公路货物运输定额险' },
        { id: 64, text: '第三者责任险' },
        { id: 128, text: '无车承运人责任险' },
        { id: 256, text: '健康险' }
      ],
      payChannelOptions: [
        { id: 1, text: '余额支付' },
        { id: 2, text: '睿保对接的微信支付' },
        { id: 4, text: '鼎盛支付' },
        { id: 8, text: '保险公司支付链接' },
        { id: 16, text: '线下支付' },
        { id: 32, text: '鼎盛余额支付' },
        { id: 64, text: '中际(科成)支付' },
        { id: 128, text: '布谷维客微信支付' }
      ],
      payTypeOptions: [
        { id: 1, text: '在线支付' },
        { id: 2, text: '余额支付' },
        { id: 16, text: '混合支付' }
      ],
      showDepositMin: false
    }
  },
  computed: {
    dialogVisible: {
      get() {
        return this.visible
      },
      set(val) {
        this.$emit('update:visible', val)
      }
    },
    dialogTitle() {
      if (this.isView) return '查看方案'
      return this.formData ? '编辑方案' : '创建方案'
    },
    isOnlinePayment() {
      return this.form.pay_type === 1 || this.form.pay_type === 16
    },
    showFeatureConfig() {
      return this.form.pay_type && this.form.pay_type !== ''
    }
  },
  watch: {
    visible(val) {
      if (val) {
        this.initForm()
        this.fetchInitialData()
      }
    },
    'form.deposit_min'(val) {
      this.showDepositMin = val > 0
    }
  },
  methods: {
    // 初始化表单
    initForm() {
      if (this.formData && this.formData.id) {
        // 编辑模式，加载数据
        this.loadFormData()
      } else {
        // 新增模式，重置表单
        this.resetForm()
      }
    },

    // 重置表单
    resetForm() {
      this.form = {
        id: null,
        product_id: '',
        insurance_type: '',
        risk_type: '',
        commission_rate: 0,
        name: '',
        rate: 0,
        min_premium: 0,
        max_coverage: 0,
        pay_channel: '',
        effect_days: 1,
        pay_type: '',
        policy_type: 1,
        effect_time_type: 1,
        policy_name: '',
        is_allow_deposit_online: false,
        is_upload_agreement: false,
        is_upload_policy_file: false,
        is_allow_deposit_offline: false,
        deposit_min: 0,
        insurance_item: '',
        deductible: '',
        special_clauses: '',
        extension_clauses: '',
        warranty_against_cargo: '',
        claim_service: '',
        policy_remark: ''
      }
      this.showDepositMin = false
    },

    // 加载表单数据
    async loadFormData() {
      if (!this.formData.id) return
      
      try {
        const response = await getSchemeInfo({ id: this.formData.id })
        if (response && response.err_code === 0) {
          const data = response.data
          this.form = {
            id: data.id,
            product_id: data.product_id,
            insurance_type: data.insurance_type,
            risk_type: data.risk_type,
            commission_rate: data.commission_rate || 0,
            name: data.name,
            rate: data.rate ? data.rate / 10000 : 0,
            min_premium: data.min_premium || 0,
            max_coverage: data.max_coverage ? data.max_coverage / 10000 : 0,
            pay_channel: data.pay_channel,
            effect_days: data.effect_days || 1,
            pay_type: data.pay_type,
            policy_type: data.policy_type || 1,
            effect_time_type: data.effect_time_type || 1,
            policy_name: data.policy_name || '',
            is_allow_deposit_online: data.is_allow_deposit_online || false,
            is_upload_agreement: data.is_upload_agreement || false,
            is_upload_policy_file: data.is_upload_policy_file || false,
            is_allow_deposit_offline: data.is_allow_deposit_offline || false,
            deposit_min: data.deposit_min || 0,
            insurance_item: data.insurance_item || '',
            deductible: data.deductible || '',
            special_clauses: data.special_clauses || '',
            extension_clauses: data.extension_clauses || '',
            warranty_against_cargo: data.warranty_against_cargo || '',
            claim_service: data.claim_service || '',
            policy_remark: data.policy_remark || ''
          }
          this.showDepositMin = this.form.deposit_min > 0
        }
      } catch (error) {
        console.error('加载方案数据失败:', error)
        this.$message.error('加载方案数据失败')
      }
    },

    // 获取初始数据
    async fetchInitialData() {
      try {
        const [productRes, insuranceRes] = await Promise.all([
          getProductList(),
          getInsuranceCompanyList()
        ])

        if (productRes && productRes.err_code === 0) {
          this.productOptions = productRes.rows || []
        }

        if (insuranceRes && insuranceRes.err_code === 0) {
          this.insuranceOptions = (insuranceRes.rows || []).map(item => ({
            id: item.id,
            text: item.name
          }))
        }
      } catch (error) {
        console.error('获取初始数据失败:', error)
      }
    },

    // 支付方式变化
    handlePayTypeChange() {
      // 重置功能配置
      this.form.is_allow_deposit_online = false
      this.form.is_upload_agreement = false
      this.form.is_upload_policy_file = false
      this.form.is_allow_deposit_offline = false
      this.form.deposit_min = 0
      this.showDepositMin = false
    },

    // 保单类型变化
    handlePolicyTypeChange() {
      // 重置相关字段
      this.form.policy_name = ''
      this.form.effect_time_type = 1
      this.form.policy_remark = ''
    },

    handleClose() {
      this.dialogVisible = false
    },

    async handleSave() {
      // 表单验证
      try {
        await this.$refs.schemeForm.validate()
      } catch (error) {
        return
      }

      this.loading = true
      try {
        // 准备提交数据
        const data = {
          ...this.form,
          calculate_type: this.getCalculateType(),
          rate: this.form.rate ? this.form.rate * 10000 : 0, // 转换为万分之一
          max_coverage: this.form.max_coverage ? this.form.max_coverage * 10000 : 0, // 转换为元
          deposit_min: this.showDepositMin ? this.form.deposit_min : 0
        }

        // 删除不必要的字段
        if (!this.isOnlinePayment) {
          delete data.is_upload_agreement
          delete data.is_upload_policy_file
        } else {
          delete data.is_allow_deposit_offline
          delete data.deposit_min
        }

        if (this.form.policy_type === 1) {
          delete data.effect_time_type
          delete data.policy_remark
        } else {
          delete data.policy_name
        }

        const response = await saveScheme(data)
        if (response && response.err_code === 0) {
          this.$message.success('保存成功')
          this.$emit('save')
          this.handleClose()
        } else {
          this.$message.error(response?.err_msg || '保存失败')
        }
      } catch (error) {
        console.error('保存失败:', error)
        this.$message.error('保存失败')
      } finally {
        this.loading = false
      }
    },

    // 获取计算类型
    getCalculateType() {
      const typeMap = {
        'coverage_rate': 1,
        'fixed_coverage': 2,
        'fixed_coverage_type': 4,
        'freight_rate': 8
      }
      return typeMap[this.schemeType] || 1
    }
  }
}
</script>

<style scoped>
.scheme-edit-form {
  padding: 20px;
  max-height: 70vh;
  overflow-y: auto;
}

.form-section {
  margin-bottom: 30px;
  padding: 20px;
  border: 1px solid #e6e6e6;
  border-radius: 6px;
  background: #fafafa;
}

.section-title {
  margin: 0 0 20px 0;
  padding-bottom: 10px;
  border-bottom: 2px solid #409eff;
  color: #409eff;
  font-size: 16px;
  font-weight: bold;
}

.el-form-item {
  margin-bottom: 18px;
}

.el-checkbox {
  margin-bottom: 10px;
  display: block;
}

/* 调整表单元素间距 */
.el-input-number {
  width: 100%;
}

/* 自定义滚动条 */
.scheme-edit-form::-webkit-scrollbar {
  width: 6px;
}

.scheme-edit-form::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 3px;
}

.scheme-edit-form::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 3px;
}

.scheme-edit-form::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}
</style>
